import { ISvgComponent } from '../../svg.models';
import * as S from '../svg.style';

export const TickV2: React.FC<ISvgComponent> = ({ color, height, width, shrinkable, ...rest }) => (
  <S.Svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height={height}
    width={width}
    viewBox="0 0 17 14"
    shrinkable={shrinkable}
    {...rest}
  >
    <path
      stroke={color}
      d="M1.64096 6.21856C1.26376 5.78996 0.657468 5.7926 0.282556 6.22519C-0.0917829 6.65712 -0.0946491 7.35667 0.276815 7.79257L5.30744 13.5971C5.4883 13.8058 5.73344 13.9231 5.98951 13.9231C6.24557 13.9231 6.49073 13.8058 6.67157 13.5971L16.7327 1.9875C16.9175 1.77948 17.0226 1.4953 17.0243 1.19717C17.0261 0.899728 16.9244 0.613546 16.7419 0.402881C16.5593 0.192216 16.3113 0.0749601 16.0529 0.0769443C15.7951 0.0789318 15.5482 0.200163 15.3685 0.41348L5.98957 11.2349L1.64096 6.21856Z"
      fill="#262626"
    />
  </S.Svg>
);

